import React from "react"
import ReactSelect from "react-select"
import * as styles from "./SupplierSignupForm.module.scss"

const { NEXT_PUBLIC_ENV } = process.env

const FormAdditional = ({
  data,
  reactSelectStyles,
  handleChangeSelect,
  handleChange,
  companySizeOptions,
}) => (
  <section>
    <h3>Additional details</h3>
    <p />
    <div>
      <label htmlFor="howmanypeopleinthecompany">How big is your team?</label>
      <ReactSelect
        styles={reactSelectStyles}
        className="react-select-container"
        id="howmanypeopleinthecompany"
        name="howmanypeopleinthecompany"
        onChange={handleChangeSelect}
        options={companySizeOptions}
        value={companySizeOptions.filter(
          (v) => data.howmanypeopleinthecompany === v.value
        )}
      />
    </div>
    <div>
      <label htmlFor="howlonginthebusiness">In which year was the company founded (YYYY)?</label>
      <input
        id="howlonginthebusiness"
        name="howlonginthebusiness"
        onChange={handleChange}
        type="text"
        pattern="[0-9]{4}"
        value={data.howlonginthebusiness}
        placeholder="e.g. 2005"
      />
    </div>
    <div className="checkbox-wrapper">
      <input
        id="publicliabilityinsurance"
        name="publicliabilityinsurance"
        onChange={handleChange}
        type="checkbox"
        checked={data.publicliabilityinsurance}
      />
      <label htmlFor="publicliabilityinsurance">Do you have Public Liability Insurance?</label>
    </div>
    <div className="checkbox-wrapper">
      <input
        id="vatregistered"
        name="vatregistered"
        onChange={handleChange}
        type="checkbox"
        checked={data.vatregistered}
      />
      <label htmlFor="vatregistered">Are you VAT registered?</label>
    </div>

    <br />
    <div>
      <label htmlFor="sustainability">Sustainability</label>
      <p>
        Do you do anything to look after our planet? Whether it is donating flowers after the event
        to a hospice or using locally sourced produce we want to know any efforts you make!
      </p>
      <textarea
        id="sustainability"
        name="sustainability"
        onChange={handleChange}
        value={data.sustainability}
      />
    </div>
  </section>
)

export default FormAdditional
